import React, { useState } from "react";
import { CardSection, Radio } from "cxa-components";
import messages from "components/messagesDescription";
import PropTypes from "prop-types";
import { intlShape, injectIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import UpArrow from "../common/ArrowUp";
import DownArrow from "../common/ArrowDown";
import withMatchMediaProps from "@hocs/with-match-media-props";

const SelectClaimList = props => {
  const { intl, claimClassifications, ...rest } = props;
  const [categoryStates, setCategoryStates] = useState({});
  const [allCollapsed, setAllCollapsed] = useState(false);

  const claimCategories = claimClassifications.flatMap(cla => cla.claimCategories);

  const toggleAllCategories = () => {
    const newCollapsedState = !allCollapsed;
    setAllCollapsed(newCollapsedState);
    setCategoryStates(
      claimCategories.reduce(
        (states, cat) => ({
          ...states,
          [cat.categoryName]: newCollapsedState,
        }),
        {}
      )
    );
  };

  const updateCategoryState = (categoryName, isCollapsed) => {
    const newStates = { ...categoryStates, [categoryName]: isCollapsed };
    setCategoryStates(newStates);
    setAllCollapsed(claimCategories.every(cat => newStates[cat.categoryName] || false));
  };

  return (
    <div className="select-claim-container csp-side-menu">
      <CardSection>
        <div className="section-label">
          <strong>{intl.formatMessage(messages.claims.selectTheTypeOfClaim)}</strong>
          <button
            className="link"
            style={{ float: "right", fontSize: "1rem" }}
            onClick={toggleAllCategories}
          >
            {allCollapsed
              ? intl.formatMessage(messages.expandAllDescription)
              : intl.formatMessage(messages.collapseAllDescription)}
          </button>
        </div>
        {claimCategories.map(cat => (
          <SelectClaimCategoryItems
            key={cat.categoryName}
            claimCategory={cat}
            collapseState={categoryStates[cat.categoryName] || false}
            setCollapseState={isCollapsed => updateCategoryState(cat.categoryName, isCollapsed)}
            intl={intl}
            {...rest}
          />
        ))}
      </CardSection>
    </div>
  );
};

SelectClaimList.propTypes = {
  intl: intlShape.isRequired,
  claimClassifications: PropTypes.array,
  selectedClaim: PropTypes.object,
  setSelectedClaim: PropTypes.func,
  showClaimsAsList: PropTypes.bool,
};

const SelectClaimCategoryItems = props => {
  const {
    intl,
    claimCategory,
    selectedClaim,
    setSelectedClaim,
    collapseState,
    setCollapseState,
    isNarrowScreen,
  } = props;
  const dispatch = useDispatch();
  const isCPFEnabled = useSelector(state => state.claimsPP.isCPFEnabled);
  return (
    <div key={claimCategory.categoryName}>
      <div className="claim-classification-section claim-category-section">
        <span>
          {intl.formatMessage({
            id: claimCategory.categoryName,
            defaultMessage: claimCategory.categoryName,
          })}
        </span>
        <button
          className="link claim-category-arrow"
          onClick={() => setCollapseState(!collapseState)}
        >
          {collapseState ? (
            <DownArrow width="20px" height="20px" />
          ) : (
            <UpArrow width="16px" height="16px" />
          )}
        </button>
      </div>
      {!collapseState &&
        claimCategory.children.map(item => (
          <Radio
            key={item.claimId}
            className="claim-radio-class"
            checked={item.claimId === (selectedClaim && selectedClaim.claimId)}
            onClick={() => dispatch(setSelectedClaim(item))}
          >
            {!isNarrowScreen ? (
              <div className="claim-list-item">
                <span className="claim-list-item-name">
                  <strong>{item.claimName}</strong>
                </span>
                <span className="claim-list-item-tags">
                  {item.cpfContributable && (
                    <span className="claim-label claim-list-item-tag">
                      {intl.formatMessage(messages.claims.cpfContributable)}
                    </span>
                  )}
                  {item.isTaxable && (
                    <span className="claim-label claim-list-item-tag">
                      {intl.formatMessage(messages.claims.taxable)}
                    </span>
                  )}
                </span>
              </div>
            ) : (
              <div>
                <div className="claim-radio">
                  <strong>{item.claimName}</strong>
                </div>
                <span>
                  {isCPFEnabled && item.cpfContributable && (
                    <span className="claim-label claim-list-item-tag">
                      {intl.formatMessage(messages.claims.cpfContributable)}
                    </span>
                  )}
                  {item.isTaxable && (
                    <span className="claim-label claim-list-item-tag">
                      {intl.formatMessage(messages.claims.taxable)}
                    </span>
                  )}
                </span>
              </div>
            )}
          </Radio>
        ))}
    </div>
  );
};

SelectClaimCategoryItems.propTypes = {
  intl: intlShape.isRequired,
  claimCategory: PropTypes.object,
  selectedClaim: PropTypes.object,
  setSelectedClaim: PropTypes.func,
  collapseState: PropTypes.bool,
  setCollapseState: PropTypes.func,
  isNarrowScreen: PropTypes.bool,
};

export default injectIntl(
  withMatchMediaProps({
    isNarrowScreen: {
      maxWidth: 680,
    },
  })(SelectClaimList)
);



// WEBPACK FOOTER //
// ./components/claim/SelectClaimList.js